module.exports = __webpack_public_path__ + "static/media/hands_27.63c0a3a2.svg";